export const wrapHeader = (text: string): React.ReactNode => {
	if (text.length <= 10) return text;
	const mid = Math.floor(text.length / 2);
	let bestSpace = -1;
	for (let i = 0; i < text.length; i++) {
		if (text[i] !== " ") continue;
		if (bestSpace === -1 || Math.abs(i - mid) < Math.abs(bestSpace - mid)) {
			bestSpace = i;
		}
	}
	if (bestSpace === -1) return text;
	return (
		<>
			{text.slice(0, bestSpace)}
			<br />
			{text.slice(bestSpace + 1)}
		</>
	);
};

export const tableHeaderStyle = {
	p: "2px 4px",
	fontSize: "0.7rem",
	fontWeight: 600,
	color: "#333",
	borderBottom: "1px solid #ccc",
	lineHeight: "1.15",
};

export const tableCellStyle = {
	p: "2px 4px",
	fontSize: "0.7rem",
	color: "#666",
	borderBottom: "none",
};

export const labelCellStyle = {
	...tableCellStyle,
	fontStyle: "italic",
	color: "#888",
};
